<template>
  <BaseCard>
    <BaseCardBody class="space-y-5">
      <h3 class="text-base font-medium">{{ page.title }}</h3>
    </BaseCardBody>
    <BaseCardBody clear-padding class="overflow-hidden relative">
      <img :src="page.cover" class="aspect-[1/1] object-cover" />
      <a
        :href="page.url"
        target="_blank"
        class="absolute inset-0 w-full h-full flex items-center justify-center group hover:bg-black hover:bg-opacity-50 transition-all"
      >
        <span
          class="hidden group-hover:inline-flex text-white border border-white px-6 py-3 hover:bg-white hover:text-black transition-all rounded"
          >VIEW PAGE</span
        >
      </a>
    </BaseCardBody>
    <BaseCardBody class="space-y-5">
      <div class="text-gray-600 text-xs">{{ createdAt }}</div>
      <p v-if="hasDescription" class="break-words text-sm">
        {{ page.descriptio }}
      </p>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasDescription() {
      return typeof this.page.description === 'string';
    },
    createdAt() {
      return moment.utc(this.page.created_at).local().format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>
